<template>
	<div class="page-content">
		<FixedTool />
		<div class="banner"><img style="width:100%;height:100%;" src="../../assets/images/ptt_class.gif"></div>
		<div class="st-name">
			<img
					:src ="detailData.store_banner"

				 alt="" class="photo">
			<div class="info">
				<div class="name">
					<span v-if="detailData.store_name">{{detailData.store_name.length >= 9 ? detailData.store_name.slice(0,9) + '...' : detailData.store_name}}</span>
					<img src="../../assets/images/vip-icon.png" alt="">
				</div>
				<div class="address">{{detailData.rname}}</div>
			</div>
			<div class="detail-btn" @click="routerToDetail">
				<span>驾校详情</span>
				<img src="../../assets/images/icon_right_white.png" alt="">
			</div>
		</div>
		<div class="class-type">
			<div class="name">

				<span>{{detailData.car_1distribution}} {{detailData.title}}</span>
				<span class="price" style="position: absolute;right: 3%;margin-top: 14px;">
          			<p><span style="color: #999999;font-weight: normal;font-size:14px;">单购价:</span><small>￥{{parseInt(detailData.shop_price)}}</small></p>
					<p style="margin-top:4px;">{{detailData.team_user_count}}人团:￥{{detailData.group_price}}</p>
        		</span>
			</div>
       <div class="youhui">预定立享{{ (detailData.shop_price-detailData.group_price).toFixed(2) }}优惠</div>
			<div class="advantages" style="margin-top: 10px">
				<div class="advantage">{{detailData.car_2distribution}}</div>
				<div class="advantage">{{detailData.car_take}}</div>
				<div class="advantage">{{detailData.time_long}}天拿本</div>

			</div>
		</div>
		<div class="class-type-detail">
			<div class="plate-title">班型详情</div>
			<div class="detail-table">
				<table class="mytable">
					<tbody>
						<tr>
							<td>训练科目</td>
							<td>科二</td>
							<td>科三</td>
						</tr>
						<tr>
							<td>车辆分配</td>
							<td>{{detailData.car_2distribution}}</td>
							<td>{{detailData.car_3distribution}}</td>
						</tr>
						<tr>
							<td>接送方式</td>
							<td colspan="2">{{detailData.car_take}}</td>
						</tr>
						<tr>
							<td>拿本时间</td>
							<td colspan="2">{{detailData.time_long}}天左右</td>
						</tr>
						<tr>
							<td>特殊服务</td>
							<td colspan="2">无</td>
						</tr>
						<tr>
							<td>适用人群</td>
							<td colspan="2">{{detailData.apply_person}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="plate-title">班型描述</div>

			<div class="class-type-desc">
                <div v-html="detailData.goods_content">

			</div>
			</div>
		</div>
		<!-- 底部操作按钮 -->
		<div class="footer">
			<div class="prompt">
				<img src="../../assets/images/icon_danger1.png" alt="">
				<span>提示：先支付预订金，领取预订该班型，到驾校即可使用</span>
			</div>
			<div class="operation">
				<div class="reservation" v-if="isFree">
					<div class="btn">免费预订</div>
				</div>
				<div class="buy" v-else>
					<a :href="'tel://' + detailData.phone"  class="tab" >
						<img src="../../assets/images/icon_phone.png" alt="">
						<span>电话</span>
					</a>
					<div class="btns">
						<div class="group " v-if="isSpellGroup">
							<div class="btn "  v-show="flag"  @click="routerToOrder(2)">
								<span class="price">￥{{detailData.price}}元</span>
								<span>单独预定</span>
							</div>
							<div class="btn" id="pt-btn" @click="routerToOrder(1)">
								<span class="price">￥{{detailData.team_amount }}元</span>
								<span>拼团预定</span>
							</div>
						</div>
						<div class="single" v-else>
							<div class="btn">￥299元单独预定</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var team_detail_id;
export default {
	name: 'ClassTypeDetail',
	components: {},
	data() {
		return {
			id: '', //班型id
      		isFree: false, //是否显示免费预订按钮
      		isSpellGroup: true, //是否显示拼团按钮
			detailData:[],
			flag:true,
    	}
	},
	methods: {
		/**
		 * 跳转驾校详情
		 * @param {number} id - 驾校id
		 */
		routerToDetail() {

            this.$router.push({ name: 'StDetail', query: { id: this.detailData.store_id }});
			//	this.$router.push({ name: 'StDetail', query: { id: 1 }});
		},
		/**
		 * 跳转确认订单页面
		 * @param {number} id - 商品id
		 * @param {number} orderType - 订单类型
		 */
		routerToOrder(orderType) {
           var  found_id = this.$route.query.found_id;
           //跟团
           if(found_id){
               this.$ajax.get('m/order/add_order', {
                   activity_id: this.$ajax.get_activity_id(),
                   team_id: this.team_id,
                   team_price_type:orderType,
                   order_prom_type: 1221,
                   team_fllow_type:"follow",
                   found_id:found_id,
                   num: 1
               }).then(order_id => {
                   //跳转到支付页面
                   this.$router.push({name: 'SureOrder', query: {order_id: order_id}});


               })
		   }else{
//拼团
			   var params = {};

			   		params = {
						activity_id: this.$ajax.get_activity_id(),
						order_prom_type: 1221,
						team_id: this.team_id,
						team_price_type:orderType,
						team_fllow_type:"open",
						num: 1
					}

			   this.$ajax.get('m/order/add_order', params).then(order_id => {
                    //跳转到支付页面
                    this.$router.push({name: 'SureOrder', query: {order_id: order_id}});

                })

           }
			return;
			this.$router.push({ name: 'SureOrder', query: { team_id: this.team_id, orderType: orderType }});
		},
        get_team_detail(team_detail_id) {
            this.$ajax.get('m/team/team_class_detail', {
                activity_id:team_detail_id
            }).then(res => {
                this.detailData = res;
            })
        },


    },
	created() {
		// 获取班型id
		team_detail_id = this.$route.query.team_detail_id;
		var  found_id = this.$route.query.found_id;
        if(found_id){
			this.flag=false;
		}
		this.team_id=team_detail_id

		this.get_team_detail(team_detail_id)
	},
	mounted() {
		if(this.flag == false){
			$('#pt-btn').css({'width': '98%'});
		}
    window.document.title='班型详情';
    setTimeout(()=>{
      window.document.title='班型详情';
    },1500);
    setTimeout(()=>{
      window.document.title='班型详情';
    },3000);
	}
}
</script>

<style lang="less" scoped>
	.page-content {
		width: 100%;
		background-color: #F8F8F8;
    padding-bottom: 100px;
		.st-name {
			width: 100%;
			height: 80px;
			background-color: #fff;
			box-sizing: border-box;
			padding-left: 15px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.photo {
				width: 80px;
				height: 60px;
				object-fit: cover;
				margin-right: 10px;
			}
			.info {
				width: 40%;
				flex: 1;
				.name {
					display: flex;
					align-items: center;
					font-size: 15px;
					font-weight: bold;
					color: #333;
					img {
						width: 14px;
						height: 14px;
						margin-left: 5px;
					}
				}
				.address {
					margin-top: 5px;
					font-size: 12px;
					color: #666;
				}
			}
			.detail-btn {
				width: 83px;
				height: 34px;
				background: linear-gradient(45deg,rgba(60,67,236,1) 0%,rgba(0,194,255,1) 100%);
				border-radius: 25px 0px 0px 25px;
				display: flex;
				align-items: center;
				justify-content: center;
				span {
					font-size: 12px;
					color: #fff;
					margin-right: 5px;
				}
			}
		}
		.class-type {
			width: 100%;
			height: 90px;
			box-sizing: border-box;
			padding: 10px 15px;
			background-color: #fff;
			margin-top: 10px;
      .youhui{
        color: #ff679b ;
        font-size: 12px;
        margin-top: 3px;
        margin-bottom: 6px;
      }
			.name {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 16px;
				font-weight: bold;
				color: #333;
				.price {
					font-size: 18px;
					color: #EB273B;
          small{
            color: #999999;
            font-weight: normal;
            text-decoration:  line-through;
          }
				}
			}
			.advantages {
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				.advantage {
					height: 18px;
					line-height: 18px;
					display: flex;
					align-items: center;
					box-sizing: border-box;
					padding: 0 6px;
					margin-right: 10px;
					background-color: #F8F8F8;
					border-radius: 3px;
					font-size: 12px;
					color: #666;
				}
			}
		}
		.class-type-detail {
			width: 100%;
			box-sizing: border-box;
			padding: 10px 15px 30px;
			background-color: #fff;
			margin: 10px 0 10px;
			.plate-title {
				font-size: 15px;
				color: #333;
			}
			.detail-table {
				width: 100%;
				margin: 10px 0 20px;
				.mytable {
					width: 100%;
					border-collapse: collapse;
					tr {
						height: 35px;
						td {
							border: 1px #E2E2E2 solid;
							text-align: center;
							font-size: 13px;
							color: #666;
						}
						td:first-child {
							color: #999;
						}
					}
				}
			}
			.class-type-desc {
				::v-deep{
					img{width: 100%;}
				}
				font-size: 13px;
				color: #999;
				margin-top: 10px;
				line-height: 20px;
			}
		}


		.footer {
			width: 100%;
			height: 90px;
			background-color: #fff;
			position: fixed;
			bottom: 0;
			left: 0;
			.prompt {
				width: 100%;
				height: 30px;
				background-color: #FFE6CD;
				box-sizing: border-box;
				padding: 0 15px;
				display: flex;
				align-items: center;
				span {
					margin-left: 5px;
					font-size: 12px;
					color: #666;
				}
			}
			.operation {
				width: 100%;
				height: 60px;
				border-top: 1px #E2E2E2 solid;
				.reservation {
					width: 100%;
					height: 100%;
					box-sizing: border-box;
					padding: 10px 15px;
					.btn {
						width: 100%;
						height: 100%;
						background: linear-gradient(45deg,rgba(60,67,236,1) 0%,rgba(0,194,255,1) 100%);
						border-radius: 25px;
						text-align: center;
						line-height: 40px;
						font-size: 15px;
						font-weight: bold;
						color: #fff;
					}
				}
				.buy {
					width: 100%;
					height: 100%;
					box-sizing: border-box;
					padding: 0 15px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.tab {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						margin-right: 20px;
						img {
							width: 20px;
						}
						span {
							font-size: 11px;
							color: #333;
							margin-top: 5px;
						}
					}
					.btns {
						width: 81%;
						flex: 1;
						.single {
							width: 100%;
							.btn {
								width: 100%;
								height: 40px;
								line-height: 40px;
								text-align: center;
								background: linear-gradient(45deg,rgba(252,100,67,1) 0%,rgba(255,176,91,1) 100%);
								border-radius: 25px;
								font-size: 15px;
								font-weight: bold;
								color: #fff;
							}
						}
						.group {
							display: flex;
							justify-content: space-between;
							.btn {
								width: 48%;
								height: 40px;
								background: linear-gradient(45deg,rgba(255,103,155,1) 0%,rgba(255,155,189,1) 100%);
								border-radius: 25px;
								font-size: 12px;
								font-weight: bold;
								color: #fff;
								display: flex;
								flex-direction: column;
								align-items: center;
								justify-content: center;
							}
							.btn:first-child {
								background: linear-gradient(45deg,rgba(252,100,67,1) 0%,rgba(255,176,91,1) 100%);
								margin-right: 9px;
							}
						}

					}

				}
			}
		}
	}

</style>
